import { render, staticRenderFns } from "./SubfamilyWholesaleDiscountsCreate.vue?vue&type=template&id=2bbfbb9f&lang=pug&"
import script from "./SubfamilyWholesaleDiscountsCreate.vue?vue&type=script&lang=js&"
export * from "./SubfamilyWholesaleDiscountsCreate.vue?vue&type=script&lang=js&"
import style0 from "./SubfamilyWholesaleDiscountsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubfamilyWholesaleDiscountsCreate.vue"
export default component.exports